var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('iframe',{staticStyle:{"width":"1400px","height":"500px"},attrs:{"src":"//sharecad.org/cadframe/load?url=https://drive.google.com/open?id=1yDZ6q6Xt4SozXrKxeJfCiKI0dYHSVTAr","scrolling":"no"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e15e13","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Report.vue
// module id = 277
// module chunks = 0